module.exports = __webpack_public_path__ + "img/expense_tracker_clipboard.3890198e.png";